import type { ReactElement } from "react";
import type { TicketKarte } from "@kundeninfo/api-client";
import { Icon, useSofortPopup } from "@kundeninfo/ui";
import { Chip } from "@kundeninfo/ui/me-design";

/**
 * DER CHIP EINES PRIVATEN TICKETS (Spec Tickets, Nachtrag 1e, F134): Schloss und Team-Kürzel, das Sofort-Popup
 * und der zugängliche Name nennen „Privat: Team <Name>". Allgemeine Tickets (`team` null) zeigen nichts. Eine
 * Stelle für Karte, Liste und Steckbrief.
 */
export function TeamChip(p: { team: TicketKarte["team"]; className?: string }): ReactElement | null {
  const text = p.team === null ? "" : `Privat: Team ${p.team.name}`;
  const popup = useSofortPopup<HTMLSpanElement>(text);
  if (p.team === null) return null;
  return (
    <span ref={popup} className={p.className} role="img" aria-label={text}>
      <Chip><Icon name="lock" size={12} /> {p.team.shortCode}</Chip>
    </span>
  );
}
